export default "__VITE_ASSET__sJU_dA0q__"